"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { MdDragIndicator } from "react-icons/md";
import ManualCall from "@/components/patient/call-modal/manual-call";
import { DraggableContainer } from "@/components/ui/draggable-container";
import { useCommunication } from "@/contexts/chat-provider";
import { useBeforeUnload } from "@/hooks/use-before-unload";
import PatientDetails from "./patient-details";
export const FloatingCallCard: React.FC = () => {
  const $ = _c(9);
  const {
    activeCall,
    endCall
  } = useCommunication();
  useBeforeUnload(!!activeCall, "You are currently on a call. Are you sure you want to leave? Your call will be disconnected.");
  if (!activeCall) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute right-0 top-0 -mr-2 -mt-2 cursor-grab text-foreground-muted hover:text-foreground-secondary"><MdDragIndicator size={24} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== activeCall.patient) {
    t1 = <PatientDetails patient={activeCall.patient} callOngoing={true} showBackButton={false} onBackClick={_temp} />;
    $[1] = activeCall.patient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== activeCall.patient || $[4] !== endCall) {
    t2 = <div className="w-full"><ManualCall patient={activeCall.patient} onCallEnd={endCall} /></div>;
    $[3] = activeCall.patient;
    $[4] = endCall;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <DraggableContainer className="w-[400px] rounded-xl border bg-background/70 p-4 shadow-lg backdrop-blur-md" defaultRight="20px" defaultTop="80px" zIndex={50} viewportPadding={8}><div className="relative space-y-4">{t0}{t1}{t2}</div></DraggableContainer>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default FloatingCallCard;
function _temp() {}